'use client'

import type { PublicationDraft } from '@/lib/publications/types'
import {
  Badge,
  FullBleedImage,
  HandmadeFrame,
  SafeText,
  clampIndex,
  getCopy,
  getDesign,
  getSectorFonts,
  getVisual,
  type HandmadePackProps,
} from '../shared/HandmadePackCore'

const images = ['https://images.unsplash.com/photo-1517836357463-d25dfeac3438?q=80&w=1200&auto=format&fit=crop','https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=1200&auto=format&fit=crop','https://images.unsplash.com/photo-1518611012118-696072aa579a?q=80&w=1200&auto=format&fit=crop','https://images.unsplash.com/photo-1549476464-37392f717541?q=80&w=1200&auto=format&fit=crop']

const fallbackSlides = [{eyebrow:'ANTES',headline:'Todo empezó con una tensión',subheadline:'Una historia clara necesita conflicto antes de solución.',cta:'Seguir historia',bullets:['Antes', 'Quiebre', 'Decisión']},{eyebrow:'CAMBIO',headline:'El momento en que algo hizo click',subheadline:'La transformación se vuelve creíble cuando se muestra el proceso.',cta:'Ver proceso',bullets:['Duda', 'Acción', 'Resultado']},{eyebrow:'DESPUÉS',headline:'El resultado no fue casualidad',subheadline:'Cierra con aprendizaje, no solo con logro.',cta:'Quiero esto',bullets:['Proceso', 'Confianza', 'Siguiente paso']}]

export default function FitnessTransformationStoryPack({ draft, activeIndex, onActiveIndexChange }: HandmadePackProps) {
  const total = fallbackSlides.length
  const idx = clampIndex(activeIndex, total)
  const design = getDesign(draft, '#B6FF3B')
  const fonts = getSectorFonts('fitness')
  const copy = getCopy(draft, idx, fallbackSlides[idx])
  const visual = getVisual(draft, idx, images[idx % images.length], { overlay: 'black', opacity: 0.55, blur: false })

  const accent = design.accent || '#B6FF3B'
  const accent2 = design.accentDeep || '#FF6B35'
  const background = '#111111'
  const surface = '#1A1A1A'
  const text = '#FFFFFF'
  const muted = 'rgba(255,255,255,0.65)'
  const border = 'rgba(255,255,255,0.16)'

  return (
    <HandmadeFrame activeIndex={idx} total={total} onActiveIndexChange={onActiveIndexChange} text={"#fff"}>

      <div className="absolute inset-0" style={{ background }} />
      <FullBleedImage {...visual} />
      <div className="absolute inset-0" style={{ background: 'linear-gradient(90deg, rgba(0,0,0,0.96), rgba(0,0,0,0.68), rgba(0,0,0,0.28))' }} />
      <div className="absolute -right-20 top-0 h-full w-[48%] -skew-x-12" style={{ background: accent, opacity: idx === 0 ? 0.95 : 0.22 }} />
      <div className="absolute left-8 top-8"><Badge color="#000" background={accent}>{copy.eyebrow}</Badge></div>
      <div className="absolute bottom-10 left-8 right-8"><SafeText className="max-w-[76%] text-[clamp(42px,10vw,78px)] font-black uppercase leading-[0.84] tracking-[-0.065em]" style={{ color: '#fff', fontFamily: fonts.heading }}>{copy.headline}</SafeText><SafeText className="mt-5 max-w-[390px] text-[17px] font-semibold leading-[1.35]" style={{ color: 'rgba(255,255,255,0.76)', fontFamily: fonts.body }}>{copy.subheadline}</SafeText><div className="mt-7 flex gap-2">{copy.bullets.slice(0,3).map((item: string, i: number) => <span key={i} className="rounded-full border border-white/15 bg-white/10 px-3 py-2 text-[11px] font-black uppercase text-white" style={{ fontFamily: fonts.label }}>{item}</span>)}</div></div>

    </HandmadeFrame>
  )
}
